export default __webpack_public_path__ + "c3f9c8cf502c01c612889866fa702baa.wasm";